export default __webpack_public_path__ + "static/media/Arm-straps of the Scattered Gods.25bc3a95.jpg";